import { ReminderEntityTypeEnum } from "web_myplann/Infrastructure/Api/Api";

/**
 * Zbytek API serializuje enumy jako *názvy* casů ("Portfolio"), a swagger je tak
 * i dokumentuje. Připomenutí jsou ale výjimka - na dvou místech BE pracuje
 * s *hodnotami* enumu (malými písmeny):
 *
 * - `GET /v2/reminders/types` dělá `ReminderEntityTypeEnum::tryFrom($entity)`
 *   (api_myplann/moduleApi/Reminder/Action/ListReminderTypesAction.php:62),
 *   takže query param musí být "portfolio" / "property".
 * - `data.entityType` u položek timeline a notifikací se plní jako `->value`
 *   (ReminderTimelineItemProvider::buildData,
 *   NotificationNavigationResolver::buildReminderTermData).
 *
 * Mapování je schválně na jednom místě: až BE tyhle dvě místa srovná se zbytkem
 * API, je to jeden soubor ke smazání.
 */
const WIRE_VALUE_BY_ENTITY_TYPE: Record<ReminderEntityTypeEnum, string> = {
	[ReminderEntityTypeEnum.Portfolio]: "portfolio",
	[ReminderEntityTypeEnum.Property]: "property",
};

const ENTITY_TYPE_BY_WIRE_VALUE: Record<string, ReminderEntityTypeEnum> = {
	portfolio: ReminderEntityTypeEnum.Portfolio,
	property: ReminderEntityTypeEnum.Property,
};

export const toReminderEntityWireValue = (
	entityType: ReminderEntityTypeEnum,
): string => WIRE_VALUE_BY_ENTITY_TYPE[entityType];

export const fromReminderEntityWireValue = (
	value: string,
): ReminderEntityTypeEnum | null => ENTITY_TYPE_BY_WIRE_VALUE[value] ?? null;
